import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = localStorage.getItem('access_token');
    // const accessToken = '9isrPcpSKSmUuIEjpBEigZ4NdbLg';
    if (accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && error.status === 401) {
          if (error.error && error.error.message == "Unauthenticated user") {
            this.router.navigate(['/unauthorized']);
          } else {
            localStorage.removeItem('access_token');
            window.location.href = environment.authUrl + '?client_id=' + environment.clientId + '&response_type=code&scope=email+openid+profile&redirect_uri=' + environment.redirectCallBackUrl;
          }
        }
        return throwError(error);
      })
    );
  }
}
